<template>
  <div>
    <Chart
      v-if="!isFirstLoad && !isError && !isNoData"
      :options="chartOptions"
    />
    <div v-else-if="isFirstLoad" class="sk-three-bounce">
      <div class="sk-child sk-bounce1"></div>
      <div class="sk-child sk-bounce2"></div>
      <div class="sk-child sk-bounce3"></div>
    </div>
    <NoData v-else-if="isNoData"/>
    <ChartError v-else class="error-container"></ChartError>
  </div>
</template>

<script>
  import {mapActions, mapGetters, mapState} from 'vuex';
  import {Chart} from 'highcharts-vue';
  import {HIGHCHARTS_DEFAULTS} from '../../constants';
  import ChartError from "../errors/ChartError";
  import NoData from "../errors/NoData";

  export default {
    name: "HourlyBandwidthUsage",
    components: {
      Chart,
      ChartError,
      NoData
    },
    props: ['sitecode','dateRange', 'searchInput'],
    mounted() {
      this.fetchHourlyBandwidthUsage({sitecode: this.sitecode, dateRange: this.dateRange, searchInput: this.searchInput});
    },
    computed: {
      ...mapState({
        hourlyBandwidthUsage: s => s.api.chartData.hourlyBandwidthUsage
      }),
      ...mapGetters(['hourlyBandwidthUsageByDepartmentSeries', 'hourlyBandwidthUsageByNonDepartmentSeries']),
      isError () {
        return this.hourlyBandwidthUsage.error;
      },
      isNoData () {
        return this.hourlyBandwidthUsageByDepartmentSeries.length === 0 && this.hourlyBandwidthUsageByNonDepartmentSeries.length === 0;
      },
      isFirstLoad() {
        return this.hourlyBandwidthUsage.loading && this.hourlyBandwidthUsage.lastUpdatedAt == null;
      },
      chartOptions() {
        return Object.assign({}, HIGHCHARTS_DEFAULTS, {
          chart: {
            type: 'area',
            zoomType: 'x',
          },
          exporting: {
            enabled: false
          },
          title: {
            text: ''
          },
          subtitle: {
            text: document.ontouchstart === undefined ?
              'Click and drag in the plot area to zoom in' : 'Pinch the chart to zoom in'
          },
          xAxis: {
            type: 'datetime'
          },
          yAxis: {
            title: {
              enabled: true,
              text: 'Bandwidth (Mbps)',
            },
            labels: {
              formatter: function () {
                return this.value + ' Mbps';
              }
            }
          },
          tooltip: {
            headerFormat: '<span style="font-size: 10px">{point.key:%H:%M - %d/%m/%Y}</span><br/>',
            pointFormat: '{point.y:,.4f} Mbps'
          },
          legend: {
            enabled: true,
          },
          plotOptions: {
            series: {
              turboThreshold: 0
            }
          },
          series: [{
            name: 'Department',
            data: this.hourlyBandwidthUsageByDepartmentSeries,
            color: '#1D428A'
          }, {
            name: 'Non-Department',
            data: this.hourlyBandwidthUsageByNonDepartmentSeries,
            color: '#6BACE4'
          }],
        });
      }
    },
    methods: {
      ...mapActions(['fetchHourlyBandwidthUsage'])
    },
    watch: {
      sitecode: function () {
        this.fetchHourlyBandwidthUsage({sitecode: this.sitecode, dateRange: this.dateRange, searchInput: this.searchInput});
      },
      dateRange: function () {
        this.fetchHourlyBandwidthUsage({sitecode: this.sitecode, dateRange: this.dateRange, searchInput: this.searchInput});
      },
      searchInput: function () {
        this.fetchHourlyBandwidthUsage({sitecode: this.sitecode, dateRange: this.dateRange, searchInput: this.searchInput});
      }
    }
  }
</script>

<style scoped>

</style>
